export const RESET = 'POST_UPDATE_RESET'
export const SET_ERROR = 'POST_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'POST_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'POST_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'POST_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'POST_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'POST_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'POST_UPDATE_FILES'



// WEBPACK FOOTER //
// ./src/store/modules/post/update/mutation_types.js